import { useEffect } from 'react'

/** Call onKey when key (e.g. 'Escape', 'Enter) pressed */
export function useKey(key: string, onKey: () => void) {
    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === key) {
                onKey()
            }
        }

        window.addEventListener('keydown', handleKeyDown)

        // Cleanup event listener on unmount
        return () => {
            window.removeEventListener('keydown', handleKeyDown)
        }
    }, [onKey])
}
